module.exports = __webpack_public_path__ + "img/ico-import.e309dfdc.svg";